import parse from "html-react-parser";

type ShippingNoticeWithCountdownProps = {
  tr_shipping_message: string;
  shipping_threshold: number;
  shipping_start_value?: number;
  tr_offer_valid_label: string;
  countdownText: string;
  isCountdownExpired: boolean;
};

export const ShippingNoticeWithCountdown = ({
  tr_shipping_message,
  shipping_threshold,
  shipping_start_value = 0,
  tr_offer_valid_label,
  countdownText,
  isCountdownExpired,
}: ShippingNoticeWithCountdownProps) => {
  const message = tr_shipping_message.replace(
    /###threshold###/g,
    `<strong>$${shipping_threshold - shipping_start_value}</strong>`,
  );
  return (
    <div className="shipping-notice shipping-countdown-combo">
      <div className="shipping-section">
        <div className="shipping-text">{parse(message)}</div>
        <div className="shipping-progress">
          <span className="progress-label-start">${shipping_start_value}</span>
          <div className="progress-track">
            <div className="progress-fill-shipping"></div>
          </div>
          <span className="progress-label-end">${shipping_threshold}</span>
        </div>
      </div>

      <div className="countdown-section">
        <div className="countdown-text">{tr_offer_valid_label}</div>
        <div
          className="countdown-display"
          id="countdownDisplay"
          style={isCountdownExpired ? { color: "var(--red)" } : undefined}
        >
          {countdownText}
        </div>
      </div>
    </div>
  );
};
